import styles from './CardArticleFileDownload.module.scss'
import { Box } from '@achieve/ascend'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { get as _get } from 'lodash-es'
import { bytesToSize } from 'utils/conversions'
import { rewriteAssetUrl } from 'utils/conversions/urls'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'

function CardArticleFileDownload({ content }) {
  const title = _get(content, 'fields.title', '')
  const downloadText = _get(content, 'fields.ctaField', '') || 'Download'
  const downloadDescription = _get(content, 'fields.description', '')
  const downloadFile = rewriteAssetUrl(_get(content, 'fields.downloadFile.fields.file.url', ''))
  const downloadFileSize = _get(content, 'fields.downloadFile.fields.file.details.size', 0)
  const downloadSize = `${bytesToSize(downloadFileSize)}`
  const image = _get(content, 'fields.image', '')
  const isMobile = useViewportSmallerThan(BREAKPOINTS.lg)

  return (
    <Box className={styles.card}>
      <Box className="relative w-[310px] h-[220px] lg:max-h-[220px]">
        <MediaImageStandard
          className={styles.image}
          content={image}
          width={310}
          layout="fill"
          objectFit="contain"
          height={isMobile ? 117 : 220}
        />
      </Box>
      <Box className={styles.info}>
        <div className={styles['title-link-container']}>
          <AchieveLink
            href={downloadFile}
            target="blank"
            download
            className={styles['title-link']}
            underline="hover"
          >
            <Typography
              className={styles.title}
              content={title}
              variant="bodyLg"
              fontWeight="bold"
              component="h3"
            />
          </AchieveLink>
        </div>
        {downloadDescription && (
          <Typography
            className={styles.description}
            content={downloadDescription}
            variant="bodySm"
          />
        )}
        <Typography className={styles.size} content={downloadSize} variant="bodySm" />
        <Box>
          <AchieveLink
            href={downloadFile}
            target="blank"
            download
            className={styles['download-link']}
            underline="hover"
          >
            <Typography content={downloadText} variant="bodySm" fontWeight="bold" />
          </AchieveLink>
        </Box>
      </Box>
    </Box>
  )
}

export { CardArticleFileDownload }
